import {useState, useCallback, useEffect} from 'react'
import {getSelectedFullDiffHash} from '@github-ui/diffs/document-hash-helpers'

export function useSelectedFullDiffHash(): string {
  const [selectedFullDiffHash, setSelectedFullDiffHash] = useState<string>('')

  const onHashChange = useCallback(() => {
    setSelectedFullDiffHash(getSelectedFullDiffHash())
  }, [])

  useEffect(() => {
    window.addEventListener('hashchange', onHashChange)
    onHashChange() // Initialize on mount
    return () => {
      window.removeEventListener('hashchange', onHashChange)
    }
  }, [onHashChange])

  return selectedFullDiffHash
}
